<template>
  <div v-if="loading" class="page-center">
    <div class="page-center-box text-center">
      <ui-loading-page />
    </div>
  </div>
  <div v-else>
    <div class="d-flex align-items-center justify-content-between">
      <div class="me-2">
        <RouterLink class="btn btn-ghost btn-back" to="/leasings">
          <LeftIcon class="icon" />
        </RouterLink>
      </div>
      <div class="flex-grow-1 page-title">Заявка № {{ route.params.id }}</div>
      <div class="ms-2" style="width: 36px"></div>
    </div>

    <div class="hr mb-4"></div>

    <div v-if="error" class="position-relative no-list-data">
      <ui-no-data-page :text="error" />
    </div>

    <div v-else>
      <nav class="page-nav mb-0">
        <ul class="page-nav__list">
          <li class="page-nav__item">
            <div class="page-nav__link" :class="{ active: status == 0 }">
              Создание расчета
            </div>
          </li>
          <!-- <li class="page-nav__item">
          <button
            @click="() => step(1)"
            :class="{ active: stepItem == 1 }"
            class="page-nav__link"
            href="/step-2.html"
          >
            Согласование КП
          </button>
        </li>
        <li class="page-nav__item">
          <button
            @click="() => step(2)"
            :class="{ active: stepItem == 2 }"
            class="page-nav__link"
            href="/step-3.html"
          >
            Заполнение анкеты
          </button>
        </li> -->
          <li class="page-nav__item">
            <div :class="{ active: status == 1 }" class="page-nav__link">
              Сбор документов
            </div>
          </li>
          <li class="page-nav__item">
            <div :class="{ active: status == 2 }" class="page-nav__link">
              Одобрение сделки
            </div>
          </li>
          <li class="page-nav__item">
            <div :class="{ active: status == 3 }" class="page-nav__link">
              Подписание договора
            </div>
          </li>
        </ul>
      </nav>

      <Step0
        v-if="status == 0"
        :leasing="leasing"
        :setLeasing="setLeasing"
        :setStatus="StatusUpdate"
      />
      <!-- <step1 v-else-if="status == 1" />
    <step2 v-else-if="status == 2" /> -->
      <step3
        v-else-if="status == 1"
        :filesPass="filesPass"
        :passport="passport"
        :setStatus="StatusUpdate"
        :setPro="addPro"
        :docs="docs"
        :leasing="leasing"
      />
      <step4
        v-else-if="status == 2"
        :leasing="leasing"
        :setStatus="StatusUpdate"
      />
      <step5
        v-else-if="status == 3"
        :leasing="leasing"
        :filesDl="filesDl"
        :filesIn="filesIn"
        :filesActsb="filesActsb"
      />
    </div>
  </div>
</template>


<script setup>
import LeftIcon from "@/assets/svg/left.vue";

import { onMounted, ref, onBeforeUnmount } from "vue";

import { postApi, dateMask, moneyMask } from "@/run";

import { useRoute } from "vue-router";

const route = useRoute();

import Step0 from "./step/step0.vue";
import Step1 from "./step/step1.vue";
import Step2 from "./step/step2.vue";
import Step3 from "./step/step3.vue";
import Step4 from "./step/step4.vue";
import Step5 from "./step/step5.vue";

const status = ref(0);
const error = ref(null);

const leasing = ref({});

const filesDl = ref({});
const filesIn = ref({});
const filesActsb = ref({});

const filesPass = ref([]);
// Паспорт руководителя из /leasing ({ recognition, unavailable }); undefined — поле не пришло.
const passport = ref(undefined);
const docs = ref([]);

const StatusUpdate = (item) => {
  status.value = item;
};

const addPro = (p) => {
  leasing.value = { ...leasing.value, ...p };
};

const loading = ref(false);

const setLeasing = (data) => {
  leasing.value = data;
};

const start = () => {
  loading.value = true;

  postApi("/leasing", {
    id: route.params.id,
  }).then((response) => {
    passport.value = response.passport;

    response.leasing &&
      response.leasing.Status &&
      (status.value = response.leasing.Status);

    response.leasing && (leasing.value = response.leasing);

    if (response.filesPass) {
      filesPass.value = response.filesPass;
    }

    if (response.docs) {
      docs.value = response.docs;
    }

    if (response.filesDl) {
      filesDl.value = response.filesDl;
    }

    if (response.filesIn) {
      filesIn.value = response.filesIn;
    }

    if (response.filesActsb) {
      filesActsb.value = response.filesActsb;
    }

    if (response.error) {
      error.value = response.error;
    }

    loading.value = false;
  });
};

let interval = null; // переменная для интервала

onMounted(() => {
  document.title = `Заявка № ${route.params.id} - STONE-XXI`;

  start();

  // запускаем интервал
  // interval = setInterval(() => {
  //   postApi("/leasing", {
  //     id: route.params.id,
  //   }).then((response) => {
  //     response.leasing &&
  //       response.leasing.Status &&
  //       (status.value = response.leasing.Status);

  //     response.leasing && (leasing.value = response.leasing);
  //   });
  // }, 10000);
});

// очищаем интервал при уничтожении компонента
onBeforeUnmount(() => {
  clearInterval(interval);
});
</script>
